import { Button, Grid, styled, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import HeaderGeneral from "../../../components/Header/HeaderGeneral";
import { GridSkeleton, SkeletonTable, SkeletonText } from "../ProfileTabPage";
import BahasaModal from "./Components/BahasaModal";
import BahasaTable from "./Components/BahasaTable";
import KegiatanSosialModal from "./Components/KegiatanSosialModal";
import KegiatanSosialTable from "./Components/KegiatanSosialTable";
import RiwayatPendidikanModal from "./Components/RiwayatPendidikanModal";
import RiwayatPendidikanTable from "./Components/RiwayatPendidikanTable";
import TrainingModal from "./Components/TrainingModal";
import TrainingTable from "./Components/TrainingTable";
import { LoadingOverlay } from "../../../components/LoadingOverlay";
import useFetchAllRiwayatPendidikan from "../../../api/effects/queries/RiwayatPendidikan/useFetchAllRiwayatPendidikan";
import useFetchAllBahasa from "../../../api/effects/queries/Bahasa/useFetchAllBahasa";
import useFetchAllTraining from "../../../api/effects/queries/Training/useFetchAllTraining";
import useFetchAllKegiatanSosial from "../../../api/effects/queries/KegiatanSosial/useFetchAllKegiatanSosial";
import { training } from "../../../api/effects/mutations/Training/useFetchTraining";


const RootGrid = styled(Grid)(({ theme }) => ({
  paddingBottom: "5%",
}));

const TitleGrid = styled(Grid)(({ theme }) => ({
  paddingLeft: "5%",
  paddingBottom: "1%",
  paddingTop: "1%",
}));
const ButtonGrid = styled(Grid)(({ theme }) => ({
  paddingRight: "5%",
  paddingBottom: "1%",
  paddingTop: "1%",
}));

type Props = {};

export default function RiwayatPendidikanPage({ }: Props) {
  const [modalPendidikanState, setModalPendidikanState] = useState(false);

  const handleOpenModalPendidikan = () => {
    setModalPendidikanState(true);
  };
  const handleCloseModalPendidikan = () => {
    setModalPendidikanState(false);
  };

  const [modalBahasaState, setModalBahasaState] = useState(false);

  const handleOpenModalBahasa = () => {
    setModalBahasaState(!modalBahasaState);
  };

  const [modalTrainingState, setModalTrainingState] = useState(false);

  const handleOpenModalTraining = () => {
    setModalTrainingState(!modalTrainingState);
  };

  const [modalKegiatanSosialState, setModalKegiatanSosialState] =
    useState(false);

  const handleOpenModalKegiatanSosial = () => {
    setModalKegiatanSosialState(!modalKegiatanSosialState);
  };

  const { data: pendidikanData, isLoading: isPendidikanLoading } = useFetchAllRiwayatPendidikan();
  const { data: bahasaData, isLoading: isBahasaLoading } = useFetchAllBahasa();
  const { data: trainingData, isLoading: isTrainingLoading } = useFetchAllTraining();
  const { data: kegiatanSosialData, isLoading: isKegiatanSosialLoading } = useFetchAllKegiatanSosial();
  const pageIsLoading = isPendidikanLoading || isBahasaLoading || isTrainingLoading || isKegiatanSosialLoading;
  // useEffect(() => {
  //   setLoading(false);
  // }, []);

  // if (loading) {
  //   return (
  //     <GridSkeleton justifyContent="center" alignItems="center">
  //       <SkeletonText variant="text" />
  //       <SkeletonTable variant="rectangular" />
  //     </GridSkeleton>
  //   );
  // }

  return (
    <>
      <RiwayatPendidikanModal
        open={modalPendidikanState}
        handleClose={handleCloseModalPendidikan}
      />
      <BahasaModal
        open={modalBahasaState}
        handleClose={handleOpenModalBahasa}
      />
      <TrainingModal
        open={modalTrainingState}
        handleClose={handleOpenModalTraining}
      />
      <KegiatanSosialModal
        open={modalKegiatanSosialState}
        handleClose={handleOpenModalKegiatanSosial}
      />
      <LoadingOverlay isLoading={pageIsLoading}>
        <RootGrid container justifyContent="center" alignItems="center">
          <TitleGrid container item xs={12} justifyContent="flex-start">
            <Typography variant="h5">Riwayat Pendidikan</Typography>
          </TitleGrid>
          <RiwayatPendidikanTable data={pendidikanData || []} />
          <ButtonGrid container item xs={12} justifyContent="flex-end">
            <Button variant="contained" onClick={handleOpenModalPendidikan} disabled={modalPendidikanState}>
              Tambah Riwayat Pendidikan
            </Button>
          </ButtonGrid>

          <TitleGrid container item xs={12} justifyContent="flex-start">
            <Typography variant="h5">Keahlian Bahasa</Typography>
          </TitleGrid>
          <BahasaTable data={bahasaData || []} />
          <ButtonGrid container item xs={12} justifyContent="flex-end">
            <Button variant="contained" onClick={handleOpenModalBahasa}>
              Tambah Keahlian Bahasa
            </Button>
          </ButtonGrid>

          <TitleGrid container item xs={12} justifyContent="flex-start">
            <Typography variant="h5">Pengalaman Training</Typography>
          </TitleGrid>
          <TrainingTable data={trainingData || []} />
          <ButtonGrid container item xs={12} justifyContent="flex-end">
            <Button variant="contained" onClick={handleOpenModalTraining}>
              Tambah Pengalaman Training
            </Button>
          </ButtonGrid>

          <TitleGrid container item xs={12} justifyContent="flex-start">
            <Typography variant="h5">
              Pengalaman Kegiatan Sosial / Organisasi (Kemasyarakatan , Sekolah,
              Kampus, Keagamaan)
            </Typography>
          </TitleGrid>
          <KegiatanSosialTable data={kegiatanSosialData || []} />
          <ButtonGrid container item xs={12} justifyContent="flex-end">
            <Button variant="contained" onClick={handleOpenModalKegiatanSosial}>
              Tambah Pengalaman Kegiatan Sosial
            </Button>
          </ButtonGrid>
        </RootGrid>
      </LoadingOverlay>
    </>
  );
}
